import React, {Component, useState} from 'react'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import {makeStyles} from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.background.paper,
    // backgroundColor: 'blue',
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}))

const items = [
  'La salle est desormais limité aux membres',
  'Chaque membre va recevoir une cle pour las salle',
  "Maximum 5 personnes dans une seance de grimpe, 3 personnes à l'intérieur en même temps",
  'La porte et le fenêtres dois etre ouvert',
  'Entre les essayes, il faut rester dehors le maximum possible',
  'Si possible, laisser les affaires dehors',
  "Utilises le désinfectant disponible a l'entree avant le début de séance puis après chaque fois qu'on se touche le visage, ou après avoir eternué, etc",
  'Si tu es le moindre malades, il faut pas venir grimper.  Si tu tousses, viens pas grimper.  Une fievre?  Viens pas grimper',
  'Rester dehors le maximum possible',
  "On peux pas eliminer le risque de Covid dans les salles de grimpe, seulement le minimiser.  Blate c'est une petite salle ou on grimpe souvent sur les meme prises et respire la meme air.\
  Si tu es dans une catégorie de risque forte, ou habites ou passes beaucoup de temps avec quelqu'un dans une de c'est catégories, c'est peut etre mieux de grimper dehors.",
]

const reservationItems = [
  "Une systeme de reservation est en place mais pas obligatoire sous l'onglet 'reserve'",
  '5 personnes peux reserver dans la meme tranche de 30 minutes',
  "Il n'y a pas de limite sur la duration de ton seance mais penses aux autres avant de reserver pour 6 heure de suite",
  "Il y aura des cours d'entrainement qui reserve la salle une ou deux fois la semaine",
  "Si t'as pas une reservation tu peux quand meme regarder si la salle est pleine, et sinon tu peux venir grimper.  Par contre,\
  si quelqu'un viens avec une reservation et la salle est pleine, les gens sans reservation dois partir pour faire de la place.",
]

export default function corona(props) {
  const classes = useStyles()

  return (
    <Grid container>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Typography variant="h4">Nouveau Regles a cause de Covid</Typography>
          <List>
            {items.map((text, index) => (
              <ListItem key={index}>
                <ListItemText primary={text} />
              </ListItem>
            ))}
          </List>
          <Typography variant="h4">Reservations</Typography>
          <List>
            {reservationItems.map((text, index) => (
              <ListItem key={index}>
                <ListItemText primary={text} />
              </ListItem>
            ))}
          </List>
          <Typography variant="h4">Memberships</Typography>
          <List>
            <ListItem>
              <ListItemText
                primary={
                  "si tu veux devenir membre contactes Nate Jenkins a 076-519-7710 ou nate.jenkins@gmail.com pour plus d'info"
                }
              />
            </ListItem>
          </List>
          <Typography variant="h4">Entrainement</Typography>
          <List>
            <ListItem>
              <ListItemText
                primary={
                  "si tu es intéressé dans les cours d'entrainement, contactes Elie Cheviux, 077 431 1178.  C'est pas necessaire d'etre membres pour prendres des cours."
                }
              />
            </ListItem>
          </List>
        </Paper>
      </Grid>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/components/Corona.jsx